<template>
  <div class="may-concern">
    <div>
      <div id="wraperRight" class="wraperRight">
        <div v-html="adhtml"></div>
        <div class="ivy_yc ivy_yc1">
          <div id="auto.ks.jgycb." class="adpos"></div>
        </div>
        <template v-if="carsData.length > 0 && page === 1">
          <div class="maybeFollow">
            <div class="title mt110">你可能还关注：</div>
          </div>
          <div class="cars-zone" v-for="(item, index) in carsData" :key="index">
            <div class="cars-left">
              <a
                :href="`//price.pcauto.com.cn/sg${item.id}/`"
                target="_blank"
                @click="countAd(4490)"
              >
                <img :src="item.photo_src || $carsDefaultImgUrl" />
              </a>
            </div>
            <div class="cars-right">
              <p class="p1">
                <a
                  :href="`//price.pcauto.com.cn/sg${item.id}/`"
                  target="_blank"
                  @click="countAd(4491)"
                  >{{ item.name }}</a
                >
              </p>
              <p class="p2">
                官方价：<a
                  :href="`//price.pcauto.com.cn/sg${item.id}/price.html`"
                  target="_blank"
                  @click="countAd(4492)"
                  >{{ item.price }}</a
                >
              </p>
              <p class="p3">
                <a
                  :href="lab.link"
                  target="_blank"
                  v-for="(lab, index) in item.labels"
                  :key="index"
                  @click="serailListBp(lab)"
                  >{{ lab.label }}</a
                >
              </p>
            </div>
          </div>
        </template>
        <div class="ivy_yc ivy_yc2">
          <div id="auto.ks.ssyc2." class="adpos"></div>
        </div>
        <div class="ivy_yc ivy_yc3">
          <div id="auto.ks.sscy3." class="adpos"></div>
        </div>
      </div>
    </div>
    <div v-if="brandOrVendorData.length > 0">
      <div class="maybeFollow">
        <div class="title mt110">你可能还关注：</div>
      </div>
      <div
        class="maybeFollowli"
        v-for="(item, index) in brandOrVendorData"
        :key="index"
      >
        <div class="left">
          <a :href="item.link" target="_blank" @click="logoBp">
            <img :src="item.logo || $brandLogoDefaultImgUrl" />
          </a>
        </div>
        <div class="right">
          <p class="p1">
            <a :href="item.link" target="_blank" @click="titleBp">{{
              item.name
            }}</a>
          </p>
          <p class="p2">
            <a
              :href="sg.link"
              target="_blank"
              :title="sg.name"
              class="ml0"
              v-for="(sg, i) in item.sg.filter((v, i) => {
                return i < 2;
              })"
              :key="i"
              @click="nameBp"
              >{{ sg.name }}</a
            >
            <a
              :href="item.all_sg_link"
              target="_blank"
              class="blue"
              v-if="item.sg.length >= 2"
              @click="allSerialBp"
              >全部车系 &gt;&gt;</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'MayConcern',
    props: {
        RightCarsConcern: {
            type: Array,
            default: () => ([])
        },
        brandOrVendorConcern: {
            type: Array,
            default: () => ([])
        },
        aSid:{
            typeof:String,
            default:""
        }
    },
    data() {
        return {
            carsData: [],
            brandOrVendorData: [],
            page: 1,
            adhtml: ''
        }
    },
    methods: {
        serailListBp(labs) { //车系时的埋点
            if(labs.label === '报价') {
                this.countAd(4493)
            }else if(labs.label === '图片') {
                this.countAd(4494)
            }else if(labs.label === '参配') {
                this.countAd(4495)
            }else if(labs.label === '论坛') {
                this.countAd(4496)
            }
        },
        logoBp() { // 品牌或厂商logo埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4501)
            }else { //厂商
                this.countAd(4497)
            }
        },
        titleBp() { // 品牌或厂商名称埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4502)
            }else { //厂商
                this.countAd(4498)
            }
        },
        nameBp() { // 车系名称埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4503)
            }else { //厂商
                this.countAd(4499)
            }
        },
        allSerialBp() { // 全部车系埋点
            if(this.$global.qType === 1) { //品牌
                this.countAd(4504)
            }else { //厂商
                this.countAd(4500)
            }
        },
        async fetchRecommend(){
            let data = {
                positionIds: "pcauto_search_result",
                userArea: this.$global.cityCode,
                serialId: this.aSid
            }
            let res = await this.fetRecommend(data)
            var pcauto_search_result;
            if(res && res.length>0 && res[0]){
                var temp = res[0].pcauto_search_result;
                if(temp && temp.length>0){
                    pcauto_search_result = temp[0];
                }
            }
            if(pcauto_search_result){
                this.adhtml += '<a id="zhiNengGuangGao" class="zhiNeng" target="_blank" href="'+pcauto_search_result.consultationUrl+'">' +
                    '<img src="'+pcauto_search_result.disseminatePic+'" ></a>';
                // $('#wraperRight').prepend(adhtml);
            }
        }
    },
    watch: {
        RightCarsConcern(n) {
            this.carsData = n
            // if(n) { //添加ivy - ad
            //     this.$utils.getScript('//ivy.pconline.com.cn/adpuba/show?id=auto.ks.jgycb.&media=js&channel=inline&trace=1')
            //     this.$utils.getScript('//ivy.pconline.com.cn/adpuba/show?id=auto.ks.ssyc2.&media=js&channel=inline&trace=1')
            //     this.$utils.getScript('//ivy.pconline.com.cn/adpuba/show?id=auto.ks.sscy3.&media=js&channel=inline&trace=1')
            //     this.$utils.getScript('https://jzz.pcauto.com.cn/competitor/recommend.do')
            // }
        },
        brandOrVendorConcern(n) {
            this.brandOrVendorData = n
            
        },
        propP(n) {
            this.page = n
        },
        aSid(n) {
            if(n){
                this.fetchRecommend()
            }
        }

    },
    beforeUpdate() {
        if(this.$global.tab.title === 'auto_index') {
            this.$nextTick(()=>{
                this.$utils.getScript('https://www1.pcauto.com.cn/customer/210415/HZD/hux_show4.js')
            })
        }
    },


};
</script>

<style lang="scss" scoped>
.may-concern {
  margin-bottom: 25px;
  .ivy_yc {
    margin-bottom: 10px;
  }
  .maybeFollow {
    .title {
      height: 27px;
      background: #f4f4f4;
      border-top: 1px solid #e0e0e0;
      line-height: 27px;
      color: #333333;
      font-weight: bold;
      padding-left: 10px;
    }
  }
  .maybeFollowli {
    display: flex;
    margin-top: 16px;
    .left {
      margin-right: 10px;
      a {
        color: #000;
        text-decoration: none;
        outline: none;
        img {
          border: 1px solid #cccccc;
        }
      }
    }
    .right {
      a {
        color: #333333;
        display: inline-block;
        word-wrap: break-word;
        word-break: break-all;
      }
      .p1 {
        width: 245px;
        font-weight: bold;
        line-height: 20px;
        height: 20px;
        overflow: hidden;
        a {
          color: #333333;
          display: inline-block;
          word-wrap: break-word;
          word-break: break-all;
        }
      }
      .p2 {
        width: 245px;
        line-height: 20px;
        height: 20px;
        overflow: hidden;
        display: flex;
        a {
          display: inline-block;
          width: 67px;
          padding-right: 10px;
        }
      }
      .blue {
        color: #225599;
      }
    }
  }
  .cars-zone {
    display: flex;
    padding: 10px 0;
    justify-content: space-between;
    border-bottom: 1px dashed #d7d7d7;
    &:last-of-type {
      border-bottom: none;
    }
    .cars-left {
      cursor: pointer;
      a {
        img {
          width: 80px;
          height: 60px;
        }
      }
    }
    .cars-right {
      width: 217px;
      p {
        line-height: 19px;
      }
      .p1 {
        cursor: pointer;
        a {
          color: #225599;
          font-weight: bold;
        }
      }
      .p2 {
        a {
          color: #cc0000;
          font-weight: bold;
        }
      }
      .p3 {
        a {
          color: #747474;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.zhiNeng {
    display: block;
    margin-bottom: 15px;
}
.zhiNeng img {
    width: 310px;
    // height: 220px;
}
</style>
